import { useTranslation } from 'react-i18next';

import { SerializableAnnotation } from '../../../types';
import { Button } from '../../shadcn-ui/button';
import {
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../../shadcn-ui/dialog2';
import { ScrollArea } from '../../shadcn-ui/scroll-area';
import ImageViewer from './ImageViewer';
import React, { useCallback, useState } from 'react';
//import LeftSidebar from "../../potree/project/LeftSidebar";


type AnnotationViewerProps = {
  annotation: Pick<SerializableAnnotation, 'title' | 'description' | 'description_short'> &
    Partial<Pick<SerializableAnnotation, 'position' | 'cameraPosition'>>;
};

const AnnotationViewer: React.FC<AnnotationViewerProps> = ({ annotation }) => {
  const { t } = useTranslation();

	let description = annotation.description;
	
	const dom = new DOMParser().parseFromString(description,'text/html');
	let images = dom.querySelectorAll('img');
	
	if (images) {
		let count = 0;
    	images.forEach(node => { 
    		if (node) {
    			var wrapper = dom.createElement('div');
    			wrapper.setAttribute('id','wrapper_img_'+count);
    			wrapper.setAttribute('class','wrapper_img');
    			/* a bit quick and dirty, not react-like, but common libraries failed */
    			//wrapper.setAttribute('onClick','imageEnlarge(this)');
    			if (node && node.parentNode) node.parentNode.insertBefore(wrapper, node);
	    		wrapper.appendChild(node);    
    			node.setAttribute('id','img_'+count);
	    		count++;	    			
    		}
    	})
	}

	description = dom.documentElement.innerHTML;	
	
	const handleClickOutside = (e:any) => {
		if (document.getElementsByClassName('image_enlarged').length > 0) {
        	let eImgs = document.getElementsByClassName('image_enlarged');
        	for (let n=0;n<eImgs.length; n++) {
        		eImgs[n].remove();
        	}
			e.preventDefault();
        }
	}

  return (
    <DialogContent className="light isViewer" aria-describedby="" 
		onPointerDownOutside={handleClickOutside}
    >
      <DialogHeader>
        <DialogTitle className="text-foreground">
          {annotation.title}
        </DialogTitle>
      </DialogHeader>

      <ScrollArea>
        <div
          className="orto-quill-viewer text-foreground [&_a]:text-[revert]"
          dangerouslySetInnerHTML={{ __html: description }}

			onClick= {(e) => {
				let el = e.target as HTMLElement;  

        		if (document.getElementsByClassName('image_enlarged').length > 0) {
        			let eImgs = document.getElementsByClassName('image_enlarged');
        			for (let n=0;n<eImgs.length; n++) {
        				eImgs[n].remove();
        			}
        		} else {

        		if (el.tagName === 'IMG') {
        			let sometest = document.getElementById('sometest');
        			let viewer = document.getElementsByClassName('isViewer')[0];
//        			if (el.classList.contains('imageEnlarge')) {
        			if (document.getElementsByClassName('image_enlarged').length > 0) {
        				//el.className = 'imageNormal';
        				// let imgEl = document.getElementById(el.id);
        				let eImgs = document.getElementsByClassName('image_enlarged');
        				for (let n=0;n<eImgs.length; n++) {
        					eImgs[n].remove();
        				}
        			} else {
        				let imgEl = document.getElementById(el.id);
        				if (el && el.id && imgEl && imgEl.parentNode) {
        					let parentimgEl = imgEl.parentNode;
        					let wrapper = document.getElementById('wrapper_'+el.id);
        					if (wrapper) {
	        					let imgEL_clone = wrapper.cloneNode(true) as HTMLDivElement || false;
	        					if (imgEL_clone) {
		    	    				viewer.after(imgEL_clone);
	    	    					imgEL_clone.setAttribute('class','image_enlarged');
			        				imgEL_clone.setAttribute('onclick','this.remove()');
			        			}
        					}
        				}
        				//el.className = 'imageEnlarge';
        			}
        		}
        		
        		}


			}}   
			
        ></div>
      </ScrollArea>

      <DialogFooter className="flex gap-4">
        <DialogClose asChild>
          <Button
            type="submit"
            className="bg-primary capitalize text-primary-foreground"
          >
            {t('close')}
          </Button>
        </DialogClose>
      </DialogFooter>
    </DialogContent>
  );
};

export default AnnotationViewer;
